import DocValueAbstract from '@pp-frontend/shared-packages/classes/doc-value/DocValueAbstract'
import { IdentityDoc } from '@pp-frontend/shared-packages/types/dto/IdentityDoc'
import required from 'vuelidate/lib/validators/required'
import { CtcAdditional } from '@pp-frontend/shared-packages/types/doc-value/CtcAdditional'

export default class extends DocValueAbstract {
  document_value: string = ''

  setValue (value: IdentityDoc) {
    this.document_value = value.document_value
  }

  docType (): string {
    return 'licence_plate'
  }

  inputMask (): string {
    return ''
  }

  validationRule (): any {
    return {
      document_value: {
        required,
        validData: (val: string) => {
          const allowChars = 'АВЕКМНОРСТУХавекмнорстухABEKMHOPCTYXabekmhopctyx'
          return !val || new RegExp(`([${allowChars}]\\d{3}[${allowChars}]{2}(\\d\\d|\\d\\d\\d))`).test(val)
        },
        validReg: (val: string) => {
          const reg: string = val ? val.substr(6) : ''
          return !reg.startsWith('00')
        }
      }
    }
  }
}
